const roles = {
  /* BLOCK TEMPLATE */
  TEMPLATE_INDEX: 'pageTemplate.index',
  TEMPLATE_UPDATE: 'pageTemplate.update',
  /* PAGE */
  PAGE_INDEX: 'page.index',
  PAGE_STORE: 'page.store',
  PAGE_UPDATE: 'page.update',
  PAGE_DESTROY: 'page.destroy',
  PAGE_APPROVED: 'page.approved',

  PAGE_COMMENT_INDEX: 'pageComment.index',
  PAGE_COMMENT_STORE: 'pageComment.store',
  /* MEDIA */
  FOLDER_STORE: 'mediaFolder.store',
  FOLDER_UPDATE: 'mediaFolder.update',
  FOLDER_DESTROY: 'mediaFolder.destroy',
  FOLDER_VIEWALL: 'mediaFolder.allFolders',
  FOLDER_GETITEMS: 'mediaFolder.getItemsByFolder',

  FILE_UPDATE: 'mediaFile.update',
  FILE_DESTROY: 'mediaFile.destroy',
  FILE_UPLOAD: 'mediaFile.uploadFile',

  TRASH_INDEX: 'mediaTrash.index',
  TRASH_RESTORE: 'mediaTrash.restore',
  TRASH_FORCEDELETE: 'mediaTrash.forceDelete',
  TRASH_EMPTY: 'mediaTrash.empty',
  /* MENU */
  MENU_INDEX: 'menu.index',
  MENU_STORE: 'menu.store',
  MENU_DESTROY: 'menu.destroy',
  MENU_MANAGE: 'menu.manage',
  /* NEWS */
  NEWS_INDEX: 'news.index',
  NEWS_STORE: 'news.store',
  NEWS_UPDATE: 'news.update',
  NEWS_DESTROY: 'news.destroy',
  NEWS_APPROVED: 'news.approved',

  NEWS_COMMENT_INDEX: 'newsComment.index',
  NEWS_COMMENT_STORE: 'newsComment.store',
  /* NEWS CATEGORY */
  NEWS_CATE_INDEX: 'newsCategory.index',
  NEWS_CATE_STORE: 'newsCategory.store',
  NEWS_CATE_UPDATE: 'newsCategory.update',
  NEWS_CATE_DESTROY: 'newsCategory.destroy',
  NEWS_CATE_APPROVED: 'newsCategory.approved',

  NEWS_CATE_COMMENT_INDEX: 'newsCategoryComment.index',
  NEWS_CATE_COMMENT_STORE: 'newsCategoryComment.store',
  /* BANNER */
  BANNER_INDEX: 'banner.index',
  BANNER_STORE: 'banner.store',
  BANNER_UPDATE: 'banner.update',
  BANNER_DESTROY: 'banner.destroy',

  BANNER_COMMENT_INDEX: 'bannerComment.index',
  BANNER_COMMENT_STORE: 'bannerComment.store',
  /* SYSTEM */
  SYSTEM_INDEX: 'configGeneral.index',
  SYSTEM_STORE: 'configGeneral.store',
  SEO_GENERAL_INDEX: 'seoGeneral.index',
  SEO_GENERAL_STORE: 'seoGeneral.store',
  SYSTEM_LOCALE_INDEX: 'configLocale.index',
  SYSTEM_LOCALE_STORE: 'configLocale.store',
  /* HEADER */
  CONFIG_HEADER_INDEX: 'configHeader.index',
  CONFIG_HEADER_STORE: 'configHeader.store',
  /* FOOTER */
  CONFIG_FOOTER_INDEX: 'configFooter.index',
  CONFIG_FOOTER_STORE: 'configFooter.store',
  /* FE TRANSLATION  */
  FE_TRANSLATION_INDEX: 'feTranslation.index',
  FE_TRANSLATION_STORE: 'feTranslation.store',
  FE_TRANSLATION_UPDATE: 'feTranslation.update',
  FE_TRANSLATION_DESTROY: 'feTranslation.destroy',
  /* CMS TRANSLATION  */
  CMS_TRANSLATION_INDEX: 'cmsTranslation.index',
  CMS_TRANSLATION_STORE: 'cmsTranslation.store',
  CMS_TRANSLATION_UPDATE: 'cmsTranslation.update',
  CMS_TRANSLATION_DESTROY: 'cmsTranslation.destroy',
  /* REDIRECT */
  REDIRECT_INDEX: 'redirect.index',
  REDIRECT_STORE: 'redirect.store',
  REDIRECT_UPDATE: 'redirect.update',
  REDIRECT_DESTROY: 'redirect.destroy',
  REDIRECT_IMPORT: 'redirect.import',
  /* FAQ */
  FAQ_INDEX: 'faq.index',
  FAQ_STORE: 'faq.store',
  FAQ_UPDATE: 'faq.update',
  FAQ_DESTROY: 'faq.destroy',
  FAQ_APPROVED: 'faq.approved',

  FAQ_COMMENT_INDEX: 'faqComment.index',
  FAQ_COMMENT_STORE: 'faqComment.store',
  /* FAQ CATEGORY */
  FAQ_CATEGORY_INDEX: 'faqCategory.index',
  FAQ_CATEGORY_STORE: 'faqCategory.store',
  FAQ_CATEGORY_UPDATE: 'faqCategory.update',
  FAQ_CATEGORY_DESTROY: 'faqCategory.destroy',
  FAQ_CATEGORY_APPROVED: 'faqCategory.approved',

  FAQ_CATEGORY_COMMENT_INDEX: 'faqCategoryComment.index',
  FAQ_CATEGORY_COMMENT_STORE: 'faqCategoryComment.store',
  /* ERROR PAGES */
  // ERROR_PAGE_400: 'configErrorsPage.error400',
  // ERROR_PAGE_403: 'configErrorsPage.error403',
  ERROR_PAGE_404: 'configErrorsPage.error404',
  // ERROR_PAGE_429: 'configErrorsPage.error429',
  // ERROR_PAGE_500: 'configErrorsPage.error500',
  /* CONTACT */
  CONTACT_INDEX: 'contact.index',
  CONTACT_UPDATE: 'contact.update',
  CONTACT_DESTROY: 'contact.destroy',
  /* CONTACT PROBLEM */
  CONTACT_PROBLEM_INDEX: 'contactProblem.index',
  CONTACT_PROBLEM_STORE: 'contactProblem.store',
  CONTACT_PROBLEM_UPDATE: 'contactProblem.update',
  CONTACT_PROBLEM_DESTROY: 'contactProblem.destroy',
  CONTACT_PROBLEM_APPROVED: 'contactProblem.approved',

  CONTACT_PROBLEM_COMMENT_INDEX: 'contactProblemComment.index',
  CONTACT_PROBLEM_COMMENT_STORE: 'contactProblemComment.store',
  /* EMAIL TEMPLATE */
  EMAIL_TEMPLATE_INDEX: 'emailTemplate.index',
  EMAIL_TEMPLATE_UPDATE: 'emailTemplate.update',

  /* FORM */
  FORM_INDEX: 'formManagement.index',
  FORM_STORE: 'formManagement.store',
  FORM_UPDATE: 'formManagement.update',
  FORM_DESTROY: 'formManagement.destroy',

  /* ActivityLogs */
  ACTIVITYLOG_INDEX: 'activityLog.index',

  /* StaticBlocks */
  STATIC_BLOCK_INDEX: 'staticBlock.index',
  STATIC_BLOCK_STORE: 'staticBlock.store',
  STATIC_BLOCK_UPDATE: 'staticBlock.update',
  STATIC_BLOCK_DESTROY: 'staticBlock.destroy',

  /* Question */
  QUESTION_INDEX: 'question.index',
  QUESTION_UPDATE: 'question.update',

  /* oldDataReportSurvey */
  OLD_DATA_REPORT_SURVEY_HEARTRISK: 'oldDataReportSurvey.heartRisk',
  OLD_DATA_REPORT_SURVEY_COUNTER: 'oldDataReportSurvey.counter',
  OLD_DATA_REPORT_SURVEY_KIDNEYRISK: 'oldDataReportSurvey.kidneyRisk',

  /* DataReportSurvey */
  REPORT_SURVEY_HEARTRISK: 'reportSurveyResult.heartRisk',
  REPORT_SURVEY_COUNTER: 'reportSurveyResult.counter',
  REPORT_SURVEY_KIDNEYRISK: 'reportSurveyResult.kidneyRisk',

  /* reports */
  REPORT_SUMMARIES: 'reports.summaries',
  REPORT_EVALUATION: 'reports.evaluation',
  REPORT_SUMMARY_GROUPS: 'reports.summaryGroups',
  REPORT_SUMMARY_EVENTS: 'reports.summaryEvents',
  REPORT_SUMMARY_QRS: 'reports.summaryQrs',
  REPORT_SUMMARY_ONLY_HAVE_QRS: 'reports.summaryOnlyHaveQrs',
  REPORT_HEART_RISK: 'reports.heartRisk',
  REPORT_KIDNEY_RISK: 'reports.kidneyRisk',
  REPORT_COUNTER: 'reports.counter',
  REPORT_SUMMARY_PERIODS: 'reports.summaryPeriods',
  REPORT_SUMMARY_HEART_RISK_PERIODS: 'reports.summaryHeartRiskPeriods',

  /* dashboard2025 */
  REPORT_TOTAL_KIOSK_BY_YEAR: 'dashboard2025.totalKioskGroupByYear',
  REPORT_COUNTER_BY_MONTH: 'dashboard2025.counterByMonth',
  REPORT_COUNTER_BY_ACCOUNT: 'dashboard2025.counterByAccount',
  REPORT_KIOSK_BY_STATUS: 'dashboard2025.getKioskByStatus',
  REPORT_ANALYTIC: 'dashboard2025.getAnalytic',
  REPORT_ANALYTIC_HEART_RISK: 'dashboard2025.getAnalyticHeartRisk',
  REPORT_ATHEROSCLEROSIS: 'dashboard2025.getAtherosclerosis',
  REPORT_ANALYTIC_KIDNEY_RISK: 'dashboard2025.getAnalyticKidneyRisk',
  REPORT_KIDNEY_RISK_V3: 'dashboard2025.getKidneyRisk',
  REPORT_HEART_RIS_V3: 'dashboard2025.getHeartRisk',
  REPORT_HEART_RISK_BY_MONTH: 'dashboard2025.getHeartRiskByMonth',
  REPORT_YTNC_BY_YEAR_MONTH: 'dashboard2025.getYTNCByYearMonth',
  REPORT_YTNC_FOR_ONE: 'dashboard2025.getYTNCForOne',
  REPORT_YTNC_FOR_TWO: 'dashboard2025.getYTNCForTwo',
  REPORT_YTNC_FOR_THREE: 'dashboard2025.getYTNCForThree',
  REPORT_YTNC_BY_HEART_RISK: 'dashboard2025.getYTNCByHeartRisk',
  REPORT_YTNC_FOR_ONE_BY_HEART_RISK: 'dashboard2025.getYTNCForOneByHeartRisk',
  REPORT_AGE_BY_KIDNEY_RISK: 'dashboard2025.getAgeByKidneyRisk',
  REPORT_ATHEROSCLEROSIS_BY_KIDNEY_RISK: 'dashboard2025.getAtherosclerosisByKidneyRisk',
  REPORT_COUNTER_CUMULATIVE_BY_MONTH: 'dashboard2025.counterCumulativeByMonth',
  REPORT_KIOSK_GROUP_REPORT: 'dashboard2025.getKioskGroupReport',
  REPORT_YTNC: 'dashboard2025.getYTNC',
  REPORT_YTNC_FOR_ONE_BY_KIDNEY_RISK: 'dashboard2025.getYTNCForOneByKidneyRisk',
  EXPORT_KIOSK_GROUP_CUMULATIVE: 'dashboard2025.exportKioskGroupCumulative',
  REPORT_COUNTER_BY_QUARTER: 'dashboard2025.counterByQuarter',

  /* reportExport */
  EXPORT_KIOSK: 'reportExport.exportKiosk',
  EXPORT_KIOSK_SURVEY: 'reportExport.exportKioskSurvey',
  EXPORT_TOTAL_KIOSK_SURVEY: 'reportExport.exportTotalKioskSurvey',
  EXPORT_TOTAL_KIOSK_SURVEY_MONTH: 'reportExport.doExportTotalKioskSurveyByMonth',
  EXPORT_KIOSK_WORKING: 'reportExport.doExportKioskWorking',

  /* SURVEY RESULT */
  SURVEY_RESULT: 'surveyResult.index',
  SURVEY_RESULT_SHOW: 'surveyResult.show',

  /* KIOSK */
  KIOSK_INDEX: 'kiosk.index',
  KIOSK_STORE: 'kiosk.store',
  KIOSK_UPDATE: 'kiosk.update',
  KIOSK_DESTROY: 'kiosk.destroy',

  /* KIOSK Group */
  KIOSK_GROUP_INDEX: 'kioskGroup.index',
  KIOSK_GROUP_STORE: 'kioskGroup.store',
  KIOSK_GROUP_UPDATE: 'kioskGroup.update',
  KIOSK_GROUP_DESTROY: 'kioskGroup.destroy',

  /* Tracking */
  SURVEY_TRACKING_INDEX: 'surveyTracking.index',
  SURVEY_TRACKING_EXPORT: 'surveyTracking.export',

  /* KIOSK Warranty */
  KIOSK_WARRANTY_INDEX: 'kioskWarranty.index',
  KIOSK_WARRANTY_STORE: 'kioskWarranty.store',
  KIOSK_WARRANTY_UPDATE: 'kioskWarranty.update',
  KIOSK_WARRANTY_DESTROY: 'kioskWarranty.destroy',

  /* EXTERNAL MANAGER */
  EXTERNAL_MANAGER_INDEX: 'externalManager.index',
  EXTERNAL_MANAGER_STORE: 'externalManager.store',
  EXTERNAL_MANAGER_UPDATE: 'externalManager.update',
  EXTERNAL_MANAGER_DESTROY: 'externalManager.destroy',

  // /* CLINIC */
  CLINIC_INDEX: 'clinic.index',
  CLINIC_STORE: 'clinic.store',
  CLINIC_UPDATE: 'clinic.update',
  CLINIC_DESTROY: 'clinic.destroy',

  HTTP_LOG: 'httpLog.index',

  // Kết quả y tế
  EXTERNAL_RESULT_INDEX: 'result.indexExternal',

  // Kết quả phòng khám
  CLINIC_RESULT: 'result.indexClinic',
};

export default roles;

export const getPermission = (rolePermission: string[], key: string): boolean => {
  if (rolePermission.includes('*') || rolePermission.includes(key)) return true;
  return false;
};
